import './App.css';
import React, { Suspense, useEffect } from 'react';
import { HashRouter } from 'react-router-dom';

import { RecoilRoot } from 'recoil';

import AppConfig from './AppConfig';
import { Agreement } from './components/Agreement';
import { SideMenu } from './components/menu/SideMenu';
import { LoadingFallback } from './components/progress/LoadingFallback';
import Layout from './pages/Layout';
import { AmplitudeAnalyticsController } from './util/analytics/AmplitudeAnalyticsController';
import { analytics } from './util/analytics/AnalyticsController';
import type { AnalyticsControllerType } from './util/analytics/AnalyticsController.types';

const initializeAnalytics = () => {
  analytics.register(
    [
      AppConfig.amplitudeApiKey && new AmplitudeAnalyticsController(AppConfig.amplitudeApiKey),
    ].filter(Boolean) as Array<Partial<AnalyticsControllerType>>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <RecoilRoot>
      <HashRouter>
        <Agreement />
        <SideMenu>
          <Suspense fallback={<LoadingFallback />}>
            <Layout />
          </Suspense>
        </SideMenu>
      </HashRouter>
    </RecoilRoot>
  );
};

export default App;
